const cartList = [
    {
        id: '1',
        img:'assets/images/products/48/img-1.png',
        title: 'Branded T-Shirts',
        category: 'Fashion',
        size: 'XL',
        color: 'Blue',
        price: 161.25,
        qty: 3
    },
    {
        id: '2',
        img:'assets/images/products/48/img-3.png',
        title: 'Fossil gen 5E smart watch',
        category: 'Watchs',
        color: 'White',
        price: 69.60,
        qty: 2
    },
    {
        id: '3',
        img:'assets/images/products/48/img-6.png',
        title: 'Olive Printed Men Round Neck',
        category: 'Fashion',
        size: 'M',
        color: 'Brown',
        price: 250.00,
        qty: 6
    },
    {
        id: '4',
        img:'assets/images/products/48/img-9.png',
        title: 'Flip-Flops and House Slippers',
        category: 'Footwear',
        size: '8',
        color: 'Green',
        price: 150.00,
        qty: 1
    },
    {
        id: '5',
        img:'assets/images/products/48/img-2.png',
        title: 'Like style travel black handbag',
        category: 'Luggage',
        color: 'Green',
        price: 89.99,
        qty: 1
    }
]

export { cartList}